import React from 'react';

// REDUX
import { getActualFps } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';

// MANAGERS

// CSS
import styles from './PhaserStatus.scss';

export const PhaserPerformanceSimple: React.FC<{}> = ({}) => {
    const gameStoreActualFps = useAppSelector(getActualFps);

    return <div className={styles.performance_simple_container}>&#9780;{gameStoreActualFps}</div>;
};
